import { render } from "./WCTipSelect.vue?vue&type=template&id=208bb897&scoped=true"
import script from "./WCTipSelect.vue?vue&type=script&lang=js"
export * from "./WCTipSelect.vue?vue&type=script&lang=js"

import "./WCTipSelect.vue?vue&type=style&index=0&id=208bb897&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208bb897"]])

export default __exports__